import React, { Component } from 'react';
import { Form, Col, Row } from 'antd';
import Big from 'big.js';
import TableEdit from './TableEdit';
import SelectShow from './SelectShow';
import './SelectApportionObj.less';

class ModalApportion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apportion: [],
    };
  }

  componentDidMount() {
    this.setState({
      apportion: this.props.choosedArr,
    });
  }

  formatData = data => {
    const apportion = [];
    data.forEach(item => {
      apportion.push({
        originName: item.title,
        originUuid: item.value,
        originType: item.type,
        count: item.count,
        price: this.getPrice(data, item),
      });
    });
    return apportion;
  };

  // 用于删除重新计算
  formatData2 = data => {
    const apportion = [];
    data.forEach(item => {
      apportion.push({
        originName: item.originName,
        originUuid: item.originUuid,
        originType: item.originType,
        count: item.count,
        price: this.getPrice(data, item),
      });
    });
    return apportion;
  };

  setChoooseArr = () => {
    const { apportion } = this.state;
    const choosedArr = [];
    apportion.forEach(item => {
      choosedArr.push(item.originUuid);
    });
  };

  getCountSum = data => {
    const countSum = data.reduce((prev, curr) => {
      return prev + curr.count;
    }, 0);
    return countSum;
  };

  getPrice = (data, item) => {
    const countSum = new Big(this.getCountSum(data) || 1);
    const count = new Big(item.count || 1);
    const price = new Big(this.props.price || 0);
    return price.div(countSum).times(count).toFixed(2);
  };

  handleChange = data => {
    const apportion = this.formatData(data);
    this.resetApportion(apportion);
  };

  handleDelete = data => {
    const apportion = this.formatData2(data);
    this.resetApportion(apportion);
  };

  resetApportion = apportion => {
    this.setState({
      apportion,
    });
    this.props.onChange(apportion);
  };

  render() {
    const { apportion } = this.state;
    const choosedArr = apportion.map(item => item.originUuid);
    return (
      <div className="selectApportion">
        <Row>
          <Col span={11}>
            <SelectShow onChange={this.handleChange} choosedArr={choosedArr} />
          </Col>
          <Col span={13}>
            <TableEdit
              data={apportion}
              onDelete={this.handleDelete}
              resetApportion={this.resetApportion}
              onHandlePriceChange={this.handlePriceChange}
              setChoooseArr={this.setChoooseArr}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default Form.create()(ModalApportion);



// WEBPACK FOOTER //
// ./src/components/comm/apportion/SelectApportionObj.js